<div style="align-content: stretch; align-items: stretch; flex-direction: column;">
        <h1 mat-dialog-title>Update RFQ</h1>
        <h5 mat-dialog-title>The following RFQ deadline will be updated as follow:</h5>
        <mat-dialog-content class="item-attachment">
            <div class="item-table-container" [hidden]="rfqDataSource.data.length == 0">
                <table class="mat-elevation-z3 table-content" mat-table multiTemplateDataRows matSort
                    [dataSource]="rfqDataSource">
                    <ng-container matColumnDef="{{ column }}" *ngFor="let column of RFQDisplayColumns">
                        <div *ngIf="column === 'RFQNumber'">
                            <th mat-header-cell *matHeaderCellDef>RFQ no.</th>
                        </div>

                        <div *ngIf="column === 'RFQDeadline'">
                            <th mat-header-cell *matHeaderCellDef>RFQ deadline</th>
                        </div>

                        <div *ngIf="column === 'NewRFQDeadline'">
                            <th mat-header-cell *matHeaderCellDef>New RFQ deadline</th>
                        </div>

                        <div *ngIf="column === 'Reason'">
                            <th mat-header-cell *matHeaderCellDef>Reason</th>
                        </div>

                        <div *ngIf="column === 'VendorName'">
                            <th mat-header-cell *matHeaderCellDef>Vendor name</th>
                        </div>

                        <div *ngIf="column === 'RFQDeadline'">
                            <td mat-cell *matCellDef="let element"
                                [ngClass]="{ 'blue-text': element['Reason'] === 'Change in vendor email and RFQ deadline' }">
                                {{ element[column] | date:
                                'dd-MMM-yy, h:mm a'}}</td>
                        </div>
                        <div *ngIf="column === 'NewRFQDeadline'">
                            <td mat-cell *matCellDef="let element"
                                [ngClass]="{ 'blue-text': element['Reason'] === 'Change in vendor email and RFQ deadline' }">
                                {{ element[column] | date:
                                'dd-MMM-yy, h:mm a'}}<span
                                    *ngIf="element['Reason'] === 'Change in vendor email and RFQ deadline'">^</span>
                            </td>
                        </div>

                        <div *ngIf="![ 'RFQDeadline', 'NewRFQDeadline', 'data'].includes(column)">
                            <td mat-cell *matCellDef="let element"
                                [ngClass]="{ 'blue-text': element['Reason'] === 'Change in vendor email and RFQ deadline' }">
                                {{ element[column] }}</td>
                        </div>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="RFQDisplayColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: RFQDisplayColumns;"></tr>
                </table>
            </div>
            <mat-paginator [hidden]="(rfqDataSource.data.length === 0)" [length]="rfqDataSource.data.length"
                [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
        </mat-dialog-content>
        <div>
            <mat-dialog-content>
                <span class="rfq-text">
                    Please verify that all information is accurate and take note that based on your document’s external
                    security classification:
                    Official (Open) or Official (Closed): The system will automatically email the vendors related to
                    your affected RFQ.
                </span>
                <br />
                <br />
                <span class="rfq-text-blue">
                    ^ For RFQ that has both the vendor contact details and RFQ deadline updated, the system will check
                    that new RFQ deadline must be later than today plus the initial calendar days you set in the
                    document. If not, system will automatically amend the new deadline. For example,
                    <br />
                    <br />

                    <ul>
                        <li>Today: 01/11/2024</li>
                        <li>Initial calendar days deadline for all vendors : 10 days</li>
                        <li>New allowable RFQ deadline: After 11/11/2024</li>
                    </ul>
                </span>
            </mat-dialog-content>
        </div>
        <div>
            <mat-dialog-actions>
                <app-button class="padBtn cancelBtn" name="Cancel" mat-dialog-close></app-button>
                <app-button style="padding: 5px;" [disabled]="disabled" type="flat-button" class="padBtn actionBtn" [name]="buttonName()" (click)="!disabled && updateAndSendRFQ()"></app-button>
            </mat-dialog-actions>
        </div>
</div>